import { drillPairFor } from '../components/shared/DrillMetricTabs';

export type PerfDrillScrollTarget = 'blockedImpact';

export type PerfDrillState = {
  metricKey: string;
  outletId: string | null;
  scrollTo?: PerfDrillScrollTarget;
};

/** Opens a performance drill-down for the selected metric tab. */
export function openPerfDrill(
  metricKey: string,
  outletId?: string | null,
): PerfDrillState {
  const pair = drillPairFor(metricKey);
  return {
    metricKey: pair?.primary ?? metricKey,
    outletId: outletId ?? null,
  };
}

export function normalizePerfDrillFromUrl(
  raw: { metricKey: string; outletId: string | null } | null,
): PerfDrillState | null {
  if (!raw) return null;
  return openPerfDrill(raw.metricKey, raw.outletId);
}
